<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="alert alert-info">
          <b>Máy tính: </b>
          <span>Dự toán chi phí khi Nâng cấp gói dịch vụ; Gia hạn gói dịch vụ; Mua thêm tài khoản người dùng</span>
        </div>
        <div class="row">
          <div class="col">
            <client-select label="Chọn khách" :model="formModel" attribute="client"></client-select>
            <template>
              <p class="d-flex justify-content-between">
                <b>{{$t('currentPlan')}}:</b>
                <span v-if="this.client">{{ this.client.privatePlan ? this.$t('privatePlan') : this.client.plan.name }}</span>
                <span v-else class="small">{{$t('notUpdated')}}</span>
              </p>
              <p class="d-flex justify-content-between">
                <b>{{$t('currentUserPrice')}}:</b>
                <span v-if="this.client">{{ planOutput.currentPrice | numFormat }} đ</span>
                <span v-else class="small">{{$t('notUpdated')}}</span>
              </p>
              <p class="d-flex justify-content-between">
                <b>{{$t('userLimit')}}:</b>
                <span v-if="this.client">{{ this.client.userLimit }}</span>
                <span v-else class="small">{{$t('notUpdated')}}</span>
              </p>
              <p class="d-flex justify-content-between">
                <b>{{$t('expireTime')}}:</b>
                <span v-if="this.client">{{ this.client.expireTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="small">{{$t('notUpdated')}}</span>
              </p>
            </template>
          </div>
          <div class="col">
            <form-select :label="$t('transaction')" :model="formModel" attribute="type" :full-width="true"
                         :options="[
                            {value: 'upgraded', text: $t('upgraded')},
                            {value: 'extend', text: $t('extend')},
                            {value: 'user', text: $t('buyUser')},
                         ]"></form-select>
            <form-date-time v-if="['upgraded', 'user'].includes(formModel.type)" :label="$t('transactionTime')"
                            :model="formModel" attribute="transactionTime" format="DD/MM/YYYY"></form-date-time>
            <template v-if="formModel.type === 'upgraded'">
              <form-select :label="$t('choosePlanToUpgrade')" :model="formModel" attribute="upgradedPlan"
                           :options="planOptions" :full-width="true"></form-select>
              <p v-if="formModel.upgradedPlan">
                <span>{{ $t("upgradedUserPrice") }}:&nbsp;</span>
                <b>{{ planOutput.upgradedPrice | numFormat }} đ</b>
              </p>
            </template>
            <template v-if="formModel.type === 'extend'">
              <form-input :label="$t('numberOfUser')" attribute="userLimit" :model="formModel"></form-input>
              <form-input :label="$t('numberOfMonthToExtend')" attribute="monthCount" :model="formModel"></form-input>
            </template>
            <template v-if="formModel.type === 'user'">
              <form-input :label="$t('numberOfUserToBuyMore')" attribute="numberOfUserToBuy" :model="formModel"></form-input>
            </template>
            <template>
              <hr class="is-primary">
              <div class="row" v-if="formModel.type === 'upgraded'">
                <div class="col-7 col-md-9 text-right">{{ $t("addedPricePerUserPerMonth") }}:</div>
                <div class="col-5 col-md-3 text-right"> <b>{{ planOutput.priceDiff | numFormat }} đ</b></div>
              </div>
              <div class="row" v-if="['upgraded', 'user'].includes(formModel.type)">
                <div class="col-7 col-md-9 text-right">{{ $t("numberOfMonthNeedPaying") }}:</div>
                <div class="col-5 col-md-3 text-right">
                  <b>{{ numberOfMonth | numFormat('0.00') }}</b>
                </div>
              </div>
              <div class="row" v-if="formModel.type === 'extend'">
                <div class="col-7 col-md-9 text-right">{{ $t('newExpireTime') }}:</div>
                <div class="col-5 col-md-3 text-right">
                  <b>{{ output.expireTime ? output.expireTime : $t('calculating') | moment('DD/MM/YYYY') }}</b></div>
              </div>
              <div class="row">
                <div class="col-7 col-md-9 text-right">{{ $t("total") }}:</div>
                <div class="col-5 col-md-3 text-right">
                  <b>{{ output.total | numFormat }} đ</b>
                </div>
              </div>
            </template>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ClientSelect from "@/components/ClientSelect";
import moment from 'moment-timezone';

export default {
  components: {ClientSelect},
  mixins: [],
  data: function () {
    return {
      client: null,
      formModel: {
        client: null,
        type: 'upgraded',
        upgradedPlan: null,
        transactionTime: Date.now(),
        userLimit: 0,
        monthCount: 12,
        numberOfUserToBuy: 0,
      },
      plans: [],
      planOptions: []
    };
  },
  watch: {
    "formModel.client": function (val) {
      if (val) {
        this.$bgService.get('/client', {
          params: {page: 1, pageSize: 100, ids: val}
        }).then(response => {
          if (response.data.docs.length) {
            let rs = response.data.docs;
            this.client = rs.find(kq => kq._id === val);
            this.formModel.userLimit = this.client.userLimit;
          }
          this.getPlans();
        });
      } else {
        this.client = null;
      }
    }
  },
  computed: {
    planOutput() {
      let output = {
        currentPrice: 0,
        upgradedPrice: 0,
        priceDiff: 0
      };
      if (this.client) {
        output.currentPrice = this.client.privatePlan ? this.client.userPrice : this.client.plan.userPrice;
        if (this.formModel.upgradedPlan && this.plans.length) {
          let p = this.plans.find(p => p._id === this.formModel.upgradedPlan);
          output.upgradedPrice = p.userPrice
        }
        if (output.currentPrice < output.upgradedPrice) {
          output.priceDiff = output.upgradedPrice - output.currentPrice
        }
      }
      return output
    },
    output() {
      let output = {
        total: 0,
        expireTime: 0
      }
      if (this.client) {
        if (this.formModel.type === 'upgraded') {
          output.total = this.planOutput.priceDiff * this.numberOfMonth * this.client.userLimit;
        }
        if (this.formModel.type === 'extend') {
          if (this.formModel.userLimit > 0 && this.formModel.monthCount > 0) {
            output.total = this.planOutput.currentPrice * this.formModel.userLimit * this.formModel.monthCount;
            let timezone = this.client.timezone ? this.client.timezone : 'Asia/Ho_Chi_Minh';
            if (this.client.expireTime > Date.now()) {
              output.expireTime = moment(this.client.expireTime).tz(timezone).add(this.formModel.monthCount, 'month').valueOf()
            } else {
              output.expireTime = moment().tz(timezone).endOf('day').add(this.formModel.monthCount, 'month').valueOf()
            }
          }
        }
        if (this.formModel.type === 'user') {
          if (this.formModel.numberOfUserToBuy) {
            output.total = +this.formModel.numberOfUserToBuy
                * this.planOutput.currentPrice
                * this.numberOfMonth;
          }
        }
      }
      return output
    },
    numberOfMonth() {
      if (!this.client) return 0;
      let timezone = this.client.timezone ? this.client.timezone : 'Asia/Ho_Chi_Minh';
      let numberOfMonth = Number(Math.round(moment(this.client.expireTime).tz(timezone).diff(moment(this.formModel.transactionTime).tz(timezone).startOf('day'), 'month', true) + 'e1') + 'e-1');
      return numberOfMonth < 0 ? 0 : numberOfMonth;
    },
    total() {
      if (!this.client) return 0;
      return this.planOutput.priceDiff * this.numberOfMonth * this.client.userLimit;
    }
  },
  methods: {
    getPlans() {
      this.planOptions = [{value: null, text: this.$t('choosePlan')}];
      this.plans.forEach(item => {
        this.planOptions.push({value: item._id, text: item.name});
      });
      if (this.client && !this.client.privatePlan) {
        this.planOptions = this.planOptions.filter(p => p.value !== this.client.plan._id)
      }
    },
  },
  mounted() {
    this.$service.get("/plan", {params: {unlimitedUser: 0, page: 1, pageSize: 1000}}).then(response => {
      this.plans = response.data.docs;
      this.getPlans();
    });
  },
  i18n: {
    messages: {
      vi: {
        currentPlan: "Gói dịch vụ hiện tại",
        currentUserPrice: "Giá/người dùng/tháng hiện tại",
        userLimit: "Số tài khoản tối đa",
        privatePlan: "Gói đặc biệt",
        choosePlanToUpgrade: "Chọn gói dịch vụ muốn nâng cấp",
        upgraded: "Nâng cấp",
        extend: "Gia hạn",
        buyUser: "Mua thêm người dùng",
        numberOfUser: "Số người dùng",
        numberOfMonthToExtend: "Số tháng muốn gia hạn",
        numberOfUserToBuyMore: "Số tài khoản muốn mua thêm",
        transaction: "Giao dịch",
        transactionTime: "Ngày giao dịch",
        upgradedUserPrice: "Giá/người dùng/tháng sau nâng cấp",
        choosePlan: "Chọn gói dịch vụ",
        total: "Tổng cộng",
        addedPricePerUserPerMonth: "Số tiền cần thanh toán/người dùng/tháng",
        numberOfMonthNeedPaying: "Số tháng cần thanh toán",
        newExpireTime: "Gia hạn đến",
        calculating: "..."
      }
    },
    en: {
      currentPlan: "Gói dịch vụ hiện tại",
      currentUserPrice: "Giá/người dùng/tháng hiện tại",
      userLimit: "Số tài khoản tối đa",
      privatePlan: "Gói đặc biệt",
      choosePlanToUpgrade: "Chọn gói dịch vụ muốn nâng cấp",
      upgraded: "Nâng cấp",
      extend: "Gia hạn",
      buyUser: "Mua thêm người dùng",
      numberOfUser: "Số người dùng",
      numberOfMonthToExtend: "Số tháng muốn gia hạn",
      numberOfUserToBuyMore: "Số tài khoản muốn mua thêm",
      transaction: "Giao dịch",
      transactionTime: "Ngày giao dịch",
      upgradedUserPrice: "Giá/người dùng/tháng sau nâng cấp",
      choosePlan: "Chọn gói dịch vụ",
      total: "Tổng cộng",
      addedPricePerUserPerMonth: "Số tiền cần thanh toán/người dùng/tháng",
      numberOfMonthNeedPaying: "Số tháng cần thanh toán",
      newExpireTime: "Gia hạn đến",
      calculating: "..."
    }
  }
};
</script>
